import React from "react";
import "../styles/Navbar.css";
import LogoDakikaNos from "../icons/Arrows/LogoDakikaNos";
import LanguagePicker from "../translations/LanguagePicker";

function Navbar() {
  return (
    <div className="navbar">
      <div className="navbar-logo">
        <LogoDakikaNos />
      </div>
      <LanguagePicker />
    </div>
  );
}

export default Navbar;
